import { render, staticRenderFns } from "./ORadio.vue?vue&type=template&id=1447c311&"
import script from "./ORadio.vue?vue&type=script&lang=js&"
export * from "./ORadio.vue?vue&type=script&lang=js&"
import style0 from "./ORadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports